import { CssVarsProvider, Sheet } from '@mui/joy';
import { ReactNode } from 'react';
import { useStateContext } from './Store/Context';

const Layout = ({ children }: { children: ReactNode }) => {

	const {medium} = useStateContext();

	if (medium === 'extension'){
		return (
			<CssVarsProvider>
				<Sheet
					variant='outlined'
					sx={{
						height: "600px",
						display: "flex",
						alignItems: "center",
						flexDirection: "column",
						justifyContent: "flex-start",
						overflow: "auto",
						padding: "5px 10px"
					}}
				>
					<div className='w-full h-full'>
						{children}
					</div>
				</Sheet>
			</CssVarsProvider>
		);
	}

	return (
		<CssVarsProvider>
			<Sheet
				sx={{
					display: "flex",
					alignItems: "center",
					flexDirection: "column",
					justifyContent: "center",
					overflow: "auto",
					padding: "5px 10px",
				}}
			>
				<div className='w-[60%] h-full'>
					{children}
				</div>
			</Sheet>
	</CssVarsProvider>
	);

}

export default Layout;